<cv-schema-render-room40-skeleton *ngIf="!itemDirectiveData.rendered"></cv-schema-render-room40-skeleton>

<div class="card room-layout" [ngClass]="cssClass" *ngIf="itemDirectiveData.rendered">
	<div *ngIf="title" class="card-header"
		 [ngStyle]="{
		 	'background-color': (layoutUIConfig?.uiConfig?.section?.header?.backgroundColor),
		 	'color': (layoutUIConfig?.uiConfig?.section?.header?.textColor)
		 }" >
		{{title}}
	</div>
	<div class="card-body" [ngClass]="this.options.bodyCssClass">
		<div class="row">
			<ng-container *ngFor="let item of layoutNode.items">
				<ng-container *ngIf="item.permissionToRender">
					<div class="{{item.options.outerCssClass}}">
						<cv-schema-render-component [layoutNode]="item" [data]="data"></cv-schema-render-component>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>
